<ng-container *transloco="let t">
  <div class="overflow-hidden bg-gold-500 pt-12 pb-22 sm:py-22" style="transform: translate3d(0, 0, 0)">
    <div class="h-layout">
      <div class="mt-12 sm:mt-22 sm:grid sm:grid-cols-12">
        <div class="text-white sm:col-span-6 sm:col-start-2">
          <h1>{{ t('createJobRequest.submitted.title') }}</h1>
          <h4 class="mt-2xl">
            {{ t('createJobRequest.submitted.subtitle', {jobNumber: jobNumber}) }}
          </h4>
        </div>
      </div>
    </div>
    <div class="absolute top-0 h-full w-full" style="z-index: -1">
      <ngx-loadable module="confetti" [show]="true"></ngx-loadable>
    </div>
  </div>
  <div class="h-layout pt-18 pb-22 sm:pt-22">
    <div class="sm:grid sm:grid-cols-12">
      <div class="sm:col-span-6 sm:col-start-2">
        <h2>{{ t('createJobRequest.submitted.nextSteps.title') }}</h2>

        <div class="mt-12">
          <bgo-why-buildigo-item
            [title]="t('createJobRequest.submitted.nextSteps.1.title')"
            [description]="t('createJobRequest.submitted.nextSteps.1.description')"
            [icon]="iconStep1"
          >
          </bgo-why-buildigo-item>
        </div>
        <div class="mt-12">
          <bgo-why-buildigo-item
            [title]="t('createJobRequest.submitted.nextSteps.2.title')"
            [description]="t('createJobRequest.submitted.nextSteps.2.description')"
            [icon]="iconStep2"
          >
          </bgo-why-buildigo-item>
        </div>
        <div class="mt-12">
          <bgo-why-buildigo-item
            [title]="t('createJobRequest.submitted.nextSteps.3.title')"
            [description]="t('createJobRequest.submitted.nextSteps.3.description')"
            [icon]="iconStep3"
          >
          </bgo-why-buildigo-item>
        </div>
      </div>
      <div class="mt-16 sm:col-span-4 sm:col-start-9 sm:mt-0">
        <cft-support-box
          [contact]="{
            name: t('createJobRequest.submitted.contactName'),
            role: t('createJobRequest.submitted.contactRole'),
            phone: t('createJobRequest.submitted.contactPhone'),
            email: t('createJobRequest.submitted.contactEmail'),
          }"
        >
          <cft-support-portrait
            [imageUrl]="'/assets/images/team/' + t('createJobRequest.submitted.photo')"
            [name]="t('createJobRequest.submitted.contactName')"
          ></cft-support-portrait>
        </cft-support-box>
      </div>
    </div>
  </div>
</ng-container>
